// extracted by mini-css-extract-plugin
export default {"form":"LoginForm_form__4pWrw","title":"LoginForm_title__XTmUR","subtitle":"LoginForm_subtitle__rvRQA","description":"LoginForm_description__5rZUM"};